require('foundation-sites/js/foundation.core');
require('foundation-sites/js/foundation.util.mediaQuery');
require('foundation-sites/js/foundation.util.keyboard');
require('foundation-sites/js/foundation.util.motion');
require('foundation-sites/js/foundation.accordion');

$(window).load ->
  $(document).foundation()



// WEBPACK FOOTER //
// ./Components/accordion.coffee